<template>
  <v-container fluid>
    <h1>{{ get("header-1") }}</h1>
    <v-row>
      <v-col cols="12" xl="8" lg="8" md="8" sm="12">
        <v-row>
          <v-col cols="12">
        <p>
          {{ get("p-1.1") }}
          {{ get("company") }} 
          {{ get("p-1.2") }}
        </p>
        <p>
          {{ get("p-1.3") }}
        </p>
        </v-col>
        </v-row>
    <v-row :class="theme + '-alt-background-1'">
      <v-col cols="12">
        <h2>
          {{ get("header-2") }}
        </h2>
        <p>
          {{ get("p-2.1") }}
          {{ get("company") }}
          {{ get("p-2.2") }}
        </p>
        <ul>
          <li>Owens Corning</li>
          <li>CertainTeed</li>
          <li>GAF</li>
          <li>TAMKO</li>
          <li>Mastic</li>
          <li>Alcoa</li>
          <li>Simonton</li>
          <li>System Home Improvements</li>
        </ul>
        <p>
          {{ get("p-2.3") }}
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h2>
          {{ get("header-3") }}
        </h2>
        <p>
          {{ get("p-3.1") }}
          {{ get("company")}}
          {{ get("p-3.2") }} 
           <phonenumber phone="(303) 778-8010"></phonenumber>
           or
           <phonenumber phone="(719) 390-7663"></phonenumber>
           {{ get("p-3.3") }}
        </p>
      </v-col>
    </v-row>
      </v-col>
      <v-col cols="12" xl="4" lg="4" md="4" sm="12">
        <estimate></estimate>
        <guild></guild>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import estimate from "../../components/controls/estimate-ctrl";
import guild from "@/components/controls/guild-quality";
import localizationMixin from "@/mixins/localization-mixin";
import phonenumber from "@/components/controls/phone-number";
import router from "@/router";

export default {
  name: "About-Home",

  components: {
    estimate,
    guild,
    phonenumber
  },

  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },

  created() {
    this.pageName = "about-home";
  },

  data: () => ({
    image: require("@/assets/roof-7.jpeg"),
  }),

  mixins: [localizationMixin],

  methods: {
    onAbout() {
      router.push("/about/home");
    },
    getLocalization(){}
  },
};
</script>

<style lang="scss" scoped>
.after-image {
  margin-top: 20px;
  margin-bottom: 20px;
}

.subtitle-span {
  background: rgba(0, 0, 0, 0.5);
  font-weight: bold;
  margin-left: 10px;
  margin-right: 10px;
  float: left;
}
</style>
